// extracted by mini-css-extract-plugin
export default {"fullWidth":"gs-z","image":"hs-z","lazyLoadPicture":"is-z","lazyLoadSpinner":"js-z","lazyLoadSpin":"ks-z","lazyLoadImage":"ls-z","hasStyledAspectRatio":"ms-z"};